import { isMobile, isTablet } from '@remarkablenet/rcm-utils/mobile-detect';
import { fetchJSON } from '../fetch-helper/fetch-helper';
import '../../../css/bem/_associated_product.scss';
import { gtag } from '../utility-functions/utility-functions';
import { handleSwatchChange } from '../wishlist/wishlist-ui';

export const wishlistGetProductId = (ele) => {
    const swatchId = ele.closest('.associated-product__inner')?.querySelector('.associated-product-colour--active')?.dataset.productid;
    if (swatchId && swatchId != "0") return swatchId;
    if (ele.dataset.pid) return ele.dataset.pid;
    return ele.closest('[data-pid]').getAttribute('data-pid');
};

export const associatedSwatchRollovers = (context = document) => {
    context.querySelectorAll('.associated-product').forEach((product) => {
        if (product.hasAttribute('data-swatches-setup')) return;
        product.setAttribute('data-swatches-setup', 'true');

        let swatches = product.querySelectorAll('.js-swatch'), //product.querySelectorAll('.color-swatch:not(.color-swatch--more)'),
            img = product.querySelector('.js-product-image'),
            debounce;

        if (img) {
            img.setAttribute('data-original', img.getAttribute('data-src') ? img.getAttribute('data-src') : img.getAttribute('src'));
        }

        let defaultSwatchUrl = '';

        if (product.querySelector('.associated-product__tile a')) {
            defaultSwatchUrl = product.querySelector('.associated-product__tile a').getAttribute('href');
        }

        let lastSelectedSwatch = product.querySelector(`.js-swatch[href="${defaultSwatchUrl}"] img`);

        swatches.forEach((swatch) => {
            swatch.addEventListener('mouseover', (evt) => {
                const swatchTarget = (evt.target as HTMLElement).closest('.js-swatch');
                if (swatchTarget) {
                    window.clearTimeout(debounce);
                    if(!img) return;
                    if (swatchTarget.getAttribute('data-image')?.length > 0) img.setAttribute('src', swatchTarget.getAttribute('data-image'));
                }
            });
            swatch.addEventListener('mouseout', (evt) => {
                if (isMobile() && isTablet()) return;

                const swatchTarget = (evt.target as HTMLElement).closest('.js-swatch');
                if (swatchTarget) {
                    debounce = window.setTimeout(() => {
                        if(!img) return;
                        if (swatchTarget.getAttribute('data-image')?.length > 0) img.setAttribute('src', img.getAttribute('data-original'));
                    }, 150);
                }
            });
            swatch.addEventListener('click', (evt) => {
                evt.preventDefault();
                evt.stopImmediatePropagation();
                const swatchTarget = (evt.target as HTMLElement).closest('.js-swatch');
                if (swatchTarget) {
                    lastSelectedSwatch = evt.target as HTMLElement;
                    if(img) img.setAttribute('src', swatchTarget.getAttribute('data-image'));
                    window.location.href = swatchTarget.getAttribute('data-href');
                }
            });
        });
    });
};

export const associatedProductAlternativeColours = (element: HTMLElement, isMobile: boolean) => {
  const state = element.querySelector<HTMLElement>('.associated-product-colours[data-state="unloaded"]');
  const colours = element.querySelectorAll<HTMLElement>('.associated-product-colour:not(.more-colours-swatch)');

  if (state && colours.length > 0) {
    state.dataset.state = 'loaded';
    colours.forEach((colour: HTMLAnchorElement) => {
      if (!isMobile) {
        colour.addEventListener('mouseover', () => updateAssociatedProduct(element, colour));
      }

      colour.addEventListener('click', (e) => {
        const productUrl = colour.dataset.product || colour.href;
        if (!productUrl) return;

        e.preventDefault();
        gtag('event', 'plp_colour_swatch_click', { product_clicked: productUrl });
        window.location.href = productUrl;
      });
    });
  }
};

const updateAssociatedProduct = (element: HTMLElement, swatch: HTMLElement) => {
    const productImg = element.querySelector<HTMLElement>('.js-product-image');
    const productLinks = element.querySelectorAll<HTMLAnchorElement>('.associated-product__link');
    const productTitle = element.querySelector<HTMLElement>('.associated-product__title');
    const productWasPrice = element.querySelector<HTMLElement>('.pricing-block--was .pricing-block__price span');
    const productNowPrice = element.querySelector<HTMLElement>('.pricing-block--now .pricing-block__price span');
    const url = swatch.dataset.url;
    const productUrl = swatch.dataset.product;

    element.querySelectorAll<HTMLElement>('.associated-product-colour--active').forEach(swatch => {
        swatch.classList.remove('associated-product-colour--active');
    });
    swatch.classList.add('associated-product-colour--active');

    productLinks.forEach((productLink) => {
        productLink.setAttribute('href', productUrl);
        productLink.setAttribute('title', swatch.dataset.title);
    });
    productImg.setAttribute('src', url);
    productTitle.innerHTML = swatch.dataset.title;
    if (productWasPrice) productWasPrice.innerHTML = swatch.dataset.fullprice;
    if (productNowPrice) productNowPrice.innerHTML = swatch.dataset.itemprice;
    
    handleSwatchChange(element, swatch);
};